var _path, _path2, _path3, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnvironment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 50,
    viewBox: "0 0 53 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2512 14.907C8.26065 19.0257 6.7319 27.2045 10.8367 33.1747L21.6835 25.7171L32.5304 18.2595C28.4256 12.2893 20.2418 10.7883 14.2512 14.907Z",
    fill: "#D8F4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2393 39.6159C23.5836 44.8795 13.1104 42.9402 7.84681 35.2845L21.7087 25.7539L35.5707 16.2234C40.8343 23.8791 38.895 34.3523 31.2393 39.6159Z",
    fill: "#BCE4CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3845 21.1427L21.0161 25.3751C24.8392 19.3564 34.3187 8.1488 34.3187 8.1488C38.3523 11.2482 41.3195 15.7655 42.3845 21.1427Z",
    fill: "#A5F0BF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.6973,
    cy: 25.8161,
    r: 7.08436,
    transform: "rotate(55.4902 21.6973 25.8161)",
    fill: "#A0D9B4",
    stroke: "#A0D9B4",
    strokeWidth: 6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/Environment.44f0bb322da4d1e0fd2c6009810cfd56.svg";
export { ForwardRef as ReactComponent };